module.exports = __webpack_public_path__ + "static/media/userCm.5a68db59.svg";